import { Fragment, useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import config from "../config";
import { Container, MainHeading, SubHeading, Text, HtmlContent } from "./Elements";
import PeriodsHistogram from './PeriodsHistogram';
import helpers from '../helpers';
import Slider from 'rc-slider';
import PlacesMap from "./PlacesMap";

function PageMenu(props) {
	const [data, setData] = useState(null);

	useEffect(() => {
		if (props.currentLang) {
			fetch(config.apiRoot+'web/pages/?in_menu=true&lang='+props.currentLang)
				.then(res => res.json())
				.then(json => {
					setData(json.results);
				});
		}
	}, [props.currentLang]);

	return data && <div className={'flex gap-2 '+props.className}>
		{
			data.map((item, index) => <NavLink key={index} className="py-1 px-2 [.active&]:bg-white hover:bg-white/20 [.active&]:text-sam_theme [.active&]:font-bold text-white inline-block rounded transition-all" to={item.url}>{item.title}</NavLink>)
		}
	</div>
}

function PageView(props) {
	const location = useLocation();
	const navigate = useNavigate();

	const { pathname } = location;

	const [data, setData] = useState(null);

	useEffect(() => {
		if (props.currentLang) {
			fetch(config.apiRoot+'web/pages/?lang='+props.currentLang+'&url='+pathname)
				.then(res => res.json())
				.then(json => {
					if (json.results.length == 0) {
						navigate('/');
					}
					setData(json.results[0]);
				});
		}
	}, [pathname, props.currentLang]);

	return data && <Container className="mt-20">
		<div className="max-w-3xl">
			<MainHeading>{data.title}</MainHeading>
			<Text text={data.content} />
		</div>
	</Container>
}

function Frontpage(props) {
	const navigate = useNavigate();

	const minYear = 1100;
	const maxYear = 1850;

	const [data, setData] = useState(null);

	useEffect(() => {
		if (props.currentLang) {
			fetch(config.apiRoot+'web/frontpage/?lang='+props.currentLang)
				.then(res => res.json())
				.then(json => {
					setData(json.results);
				});
		}
	}, [props.currentLang]);

	return <div>
		{
			data && data.map((item, index) => {
				let containerElement = <Container className={'pt-16 pb-20'}>

					{
						item.type == 'gray' && <div>
							<div className="font-bold mb-2">{window.l('Search the archive')}</div>

							<input type="text"
								className="p-2 block w-full rounded border border-gray-300 shadow focus:shadow-gray outline-1"
								onChange={(event) => {
								}}
								onKeyDown={(event) => {
									if (event.key == 'Enter') {
										navigate('/archive/?leit='+event.target.value)
									}
								}} 
							/>
						</div>
					}
					{
						item.type == 'gray' && <div className="mt-6 mb-16 text-center">
							<div className="font-bold mb-2">{window.l('Charter collection')}</div>

							<div className="md:flex justify-center">
								<Link to="/archive/?safnmark=AM Dipl. Dan." className="block mb-2 md:mb-0 btn btn-gray mr-2 font-lido text-xl">AM Dipl. Dan.</Link>
								<Link to="/archive/?safnmark=AM Dipl. Isl." className="block mb-2 md:mb-0 btn btn-gray mr-2 font-lido text-xl">AM Dipl. Isl.</Link>
								<Link to="/archive/?safnmark=AM Dipl. Norv." className="block mb-2 md:mb-0 btn btn-gray mr-2 font-lido text-xl">AM Dipl. Norv.</Link>
							</div>
						</div>
					}
					{
						item.type == 'gray' && <div>
							{
								item.title && <MainHeading>{item.title}</MainHeading>
							}
							<Text text={item.content} />
							{
								item.content_lower && <HtmlContent className="mt-10" html={item.content_lower} />
							}
						</div>
					}
					{
						item.type == 'default' && <Fragment>
							{
								item.title && <SubHeading>{item.title}</SubHeading>
							}
							<Text className="max-w-4xl" text={item.content} />
							{
								item.content_lower && <HtmlContent className="mt-10" html={item.content_lower} />
							}
						</Fragment>
					}
				</Container>;

				if (item.type == 'gray') {
					return 	<div className="bg-gray-100 bg-cover bg-top" style={{backgroundImage: 'url(/img/header-bg.png)'}}>
						{containerElement}
					</div>
				}
				else {
					return containerElement;
				}
			})
		}

		<Container className="mt-20">
			<SubHeading>{window.l('Map')}</SubHeading>
			<Text className="mb-5">{window.l('Map over origin places of documents in the archive.')}</Text>
			<PlacesMap />
		</Container>

		<Container className="mt-20">
			<SubHeading>{window.l('Documents by periods')}</SubHeading>
			<Text className="mb-5">{window.l('Here you can see the number of documents in the archive by period. You can click on each period or year to see documents from the time.')}</Text>
			<PeriodsHistogram sliderMarks={helpers.createSliderMarks(minYear, maxYear)} onSelect={(event) => {
				navigate('/archive?timabil='+event.join(','))
				//setTimeRangeValue(event);
				//updateSelectedFilters('timabil', event, true);
			}} />

			<Slider min={minYear} 
				max={maxYear} 
				value={[minYear, maxYear]} 
				range={true}
				styles={{
					handle: {
						borderColor: '#777',
						borderWidth: 1,
						backgroundColor: '#ccc',
						borderRadius: 4,
						height: 20,
						marginTop: -8
					},
					
					track: {
						backgroundColor: '#006841'
					}
				}}
				dotStyle={{
					borderColor: '#006841'
				}}
				marks={helpers.createSliderMarks(minYear, maxYear)} 
				onChangeComplete={(event) => {
					//updateUrl(selectedFilters);
				}} 
				onChange={(event) => {
					//setTimeRangeValue(event);
					//updateSelectedFilters('timabil', event, false);
				}} 
			/>
		</Container>

	</div>
}

export {
	PageMenu,
	PageView,
	Frontpage
}